import { Step } from '../../shared/interface';
import { RouterHelpers } from '../router/router-helpers';

const getCurrentHref = (): string =>
  typeof window !== 'undefined' && window.location ? window.location.href : '';

const getCurrentPathname = (): string | undefined =>
  typeof window !== 'undefined' && window.location ? window.location.pathname : undefined;

export const getResumePathWithoutToken = (href: string = getCurrentHref()): string => {
  if (!href) {
    return '';
  }

  const url = new URL(href, getCurrentHref());
  url.searchParams.delete('token');

  const search = url.searchParams.toString();
  return `${url.origin}${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
};

const matchesRoute = (pathname: string, route: string): boolean =>
  pathname === route || pathname.startsWith(`${route}/`);

const saveForLaterRouteStepMappings: Array<{ paths: string[]; step: Step }> = [
  {
    paths: [
      RouterHelpers.getMatchMakerQuestionPage1Path(),
      RouterHelpers.getMatchMakerQuestionPage1EditPath()
    ],
    step: Step.MM1
  },
  {
    paths: [
      RouterHelpers.getMatchMakerQuestionPage2Path(),
      RouterHelpers.getMatchMakerQuestionPage2EditPath()
    ],
    step: Step.MM2
  },
  {
    paths: [RouterHelpers.getPersonalDetailsPath()],
    step: Step.CONTACT_DETAILS
  },
  {
    paths: [
      RouterHelpers.getDealerSelectionPagePath(),
      RouterHelpers.getDealerSelectionEditPagePath()
    ],
    step: Step.DEALER_SELECTION
  },
  {
    paths: [RouterHelpers.getSummaryPagePath(), RouterHelpers.getConfirmationPagePath()],
    step: Step.FINAL_CONFIRMATION
  }
];

export const getSaveForLaterStepFromPath = (
  pathname: string | undefined = getCurrentPathname()
): Step | undefined =>
  pathname
    ? saveForLaterRouteStepMappings.find(({ paths }) =>
      paths.some((path) => matchesRoute(pathname, path))
    )?.step
    : undefined;


